import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/fees`;

export const getConfigurableServiceTypes = async () => {
  const requestUrl = `${baseRoute}/configurableServiceTypes`;
  const headers = getHeaders();
  const response = await fetch(requestUrl, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateConfigurableServiceTypes = async serviceTypes => {
  const requestUrl = `${baseRoute}/configurableServiceTypes`;
  const headers = getHeaders();
  const response = await fetch(requestUrl, {
    method: 'PUT',
    headers,
    body: JSON.stringify(serviceTypes),
  });
  if (response.ok) {
    return response.status === 204 ? {} : await response.json().catch(() => ({}));
  }
  const error = await response.json().catch(() => response);
  return Promise.reject(error);
};
